import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import { useEffect, useState } from "react";
import MyBetItem from "./my-bet-item";
import styles from "./styles.module.css";
import { Bet } from "interfaces/bet.ts";
import BetDetailsModal from "components/my-bets/bet-details-modal.tsx";
import { PulseLoader } from "react-spinners";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { fetchBets, getBetsState } from "state/slices/bets-slice";
import { getGroupState } from "state/slices/group-slice";
import {
  getIntegratedAppState,
  IntegratedAppState,
} from "state/slices/integrated-app-slice";
import useWagerWire from "hooks/useWagerWire";

interface Props {
  contestEntryId?: string;
  setLoading?: (loading: boolean) => void;
}

const MyBets = ({ contestEntryId, setLoading }: Props) => {
  const { wagerWireClosed, setWagerWireClosed } = useWagerWire();
  const { bets, loadingBets } = useAppSelector(getBetsState);

  const dispatch = useAppDispatch();
  const [selectedBet, setSelectedBet] = useState<Bet>();
  const groupId = useAppSelector(getGroupState).id;
  const integratedAppState = useAppSelector(getIntegratedAppState);
  const isIntegratedApp = integratedAppState.isIntegratedApp;

  useEffect(() => {
    setWagerWireClosed(false);

    if (integratedAppState.state === IntegratedAppState.UNDEFINED) {
      return;
    }

    if (!isIntegratedApp && !groupId) {
      return;
    }

    dispatch(
      fetchBets({
        groupId,
        contestEntryId: contestEntryId || "",
        isIntegratedApp,
      })
    );
  }, [groupId, contestEntryId, integratedAppState.state, wagerWireClosed]);

  if (loadingBets || !bets) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}
      >
        <PulseLoader color={"white"} size={7} />
      </div>
    );
  }

  return (
    <>
      {bets.length >= 1 ? (
        bets.map((bet, index) => (
          <MyBetItem onClick={(b) => setSelectedBet(b)} key={index} bet={bet} />
        ))
      ) : (
        <div className={styles.noBetsTextContainer}>
          <BlockyHeavyText>You haven't made any picks yet</BlockyHeavyText>
        </div>
      )}

      {selectedBet && (
        <BetDetailsModal
          bet={selectedBet}
          onHide={() => setSelectedBet(undefined)}
        />
      )}
    </>
  );
};

export default MyBets;
